import 'App.css';
import "react-datepicker/dist/react-datepicker.css";
import 'react-bootstrap-typeahead/css/Typeahead.css';

import * as actions_assets from 'actions/assets-actions';
import * as actions_authentication from 'actions/authentication-actions';
import * as actions_company from 'actions/company-actions';
import * as actions_profile from 'actions/profiles-actions';
import * as actions_service_items from 'actions/service-items-actions';
import * as actions_service_requests from 'actions/service-request-actions';
import * as actions_settings from 'actions/settings-actions';
import * as actions_users from 'actions/users-actions';
import Archive from './archive/archive';
import CatchErrors from 'components/common/catch-errors';
import Dashboard from './dashboard/dashboard';
import Footer from './layout/footer';
import Navbar from './layout/navbar';
import QuickbooksConnect from './quickbooks/quickbooks-connect';
import React from 'react';
import SideMenu from './layout/side-menu';
import Signature from './signature/signature';
import StockParts from 'components/stock-parts/stock-parts';
import firebase from 'firebase/compat/app';
import metadata from '../metadata.json';
import { AccountDelete, Login, PasswordReset, Register, Spinner, UserNotFound } from 'enspire-manager-framework';
import { ROLES } from 'components/common/constants';
import { Redirect, Route, Switch } from "react-router-dom";
import { connect } from 'react-redux';
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { withRouter } from 'react-router';

const moment = require('moment');
const Assets = React.lazy(() => import('./assets/assets'));
const Employees = React.lazy(() => import('./employees/employees'));
const Schedule = React.lazy(() => import('./schedule/schedule'));
const Settings = React.lazy(() => import('./settings/settings'));
const Vendors = React.lazy(() => import('./vendors/vendors'));

var unsubscribe = null;

class App extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			menuId: 1,
			newVersionNotified: false,
		};
		this.menu = React.createRef();
	}

	componentDidMount() {
		this.componentDidUpdate(null);
	}
	componentDidUpdate(prevProps) {

		if (this.props.match.params.handle != prevProps?.match.params.handle) {
			if (typeof unsubscribe === 'function') unsubscribe();
			unsubscribe = onAuthStateChanged(getAuth(), (user) => {
				if (user) {
					this.props.dispatch(actions_authentication.validateLogin(this.props.match.params.handle, user, (result) => {

						if (result === 'not_found') this.props.history.push('/' + this.props.match.params.handle + '/user_not_found/' + user.email);
						if (result === 'success') {
							this.props.dispatch(actions_service_items.subServiceItemCategories(this.props.match.params.handle));
							this.props.dispatch(actions_settings.subSettings(this.props.match.params.handle));
							this.props.dispatch(actions_settings.subDepartments(this.props.match.params.handle));
							this.props.dispatch(actions_settings.subJobCategories(this.props.match.params.handle));
							this.props.dispatch(actions_settings.subDepartmentTags(this.props.match.params.handle));
							this.props.dispatch(actions_settings.subAssetTypes(this.props.match.params.handle));
							this.props.dispatch(actions_settings.subAssetClassification(this.props.match.params.handle));
							this.props.dispatch(actions_settings.subPartsCategories(this.props.match.params.handle));
							this.props.dispatch(actions_assets.subAssets(this.props.match.params.handle));
							this.props.dispatch(actions_service_requests.subServiceRequests(this.props.match.params.handle));
							this.props.dispatch(actions_company.subCompany(this.props.match.params.handle));
							this.props.dispatch(actions_profile.subEmployees(this.props.match.params.handle));
							this.props.dispatch(actions_profile.subVendors(this.props.match.params.handle));
							this.props.dispatch(actions_users.subUserRecentItems(this.props.match.params.handle, user.email));
							this.props.dispatch(actions_users.subUser(this.props.match.params.handle, user.email, (userdata) => {

								if (
									this.props.location.pathname.includes('/login') || 
									this.props.location.pathname.includes('/register_user') ||
									this.props.location.pathname.includes('/register_company')
								) {

									if (userdata.roles?.includes(ROLES.ADMINISTRATOR.id) || userdata.roles?.includes(ROLES.OWNER.id)) { // administrator
										this.props.history.push('/' + this.props.match.params.handle + '/dashboard');
									} else {
										this.props.history.push('/' + this.props.match.params.handle + '/user_not_found/' + user.email);
									}
								}
							}));
						}
					}));
				} else {
					console.log('logged out');
					if (
						!this.props.location.pathname.includes('/login') &&
						!this.props.location.pathname.includes('/register_user') &&
						!this.props.location.pathname.includes('/email_link') &&
						!this.props.location.pathname.includes('signature')
					) {
						this.props.history.push('/' + this.props.match.params.handle + '/login');
					}
				}
			});

			if (this.props.location.pathname.includes('/register_user')) this.props.dispatch(actions_authentication.logout());
			if (this.props.location.pathname.endsWith('/dual_monitor')) {
				this.setState({ monitor2: true }, () => {
					this.props.history.push('/' + this.props.match.params.handle + '/schedule/' + moment().format('YYYY-MM-DD'), '_blank');
				});
			}
		}
		if (!this.state.newVersionNotified && metadata.buildRevision && this.props.settings.settings_version?.build && metadata.buildRevision < this.props.settings.settings_version?.build) {
			this.setState({ newVersionNotified: true }, () => {
				window.toastr.info('Please click "Refresh" to download the latest version of this software.', 'UPDATED VERSION AVAILABLE!');
			});
		}
	}
	toggleMenuCollapsed() {
		this.props.dispatch(actions_settings.toggleMenuCollapsed());
	}

	render() {

		const handle = this.props.match.params.handle;

		return (

			<Switch>

				<Route exact path={'/' + handle} render={(route_props) =>
					<Redirect to={'/' + handle + '/login'} />
				} />
				<Route path={this.props.match.path + '/login/:base64?'} render={(route_props) =>
					<Login landing={'/'} firebase={firebase} {...this.props} {...route_props} />
				} />
				<Route path={this.props.match.path + '/register_user/:first?/:last?/:email?'} render={(route_props) =>
					<Register landing={'/'} firebase={firebase} {...this.props} {...route_props} />
				} />
				<Route path={this.props.match.path + '/account_delete'} render={(route_props) =>
					<AccountDelete handle={handle} firebase={firebase} {...this.props} {...route_props} />
				} />

				<Route path={this.props.match.path + '/user_not_found/:email'} render={(route_props) =>
					<UserNotFound firebase={firebase} {...this.props} />
				} />
				<Route path={this.props.match.path + '/password_reset'} render={(route_props) =>
					<PasswordReset firebase={firebase} {...this.props} />
				} />
				<Route path={this.props.match.path + '/quickbooks'} render={(route_props) =>
					<QuickbooksConnect firebase={firebase} {...route_props} />
				} />
				<Route path={this.props.match.path + '/signature/:item/:id/:validateSignature'} render={(route_props) =>
					<Signature firebase={firebase} {...route_props} />
				} />
				<Route path={this.props.match.path} render={(route_props) =>
					<>
						<SideMenu
							handle={handle}
							location={this.props.location}
							user={this.props.users?.user}
							userRoles={Object.values(ROLES)}
							collapsed={this.props.settings.collapsed}
						/>
						<Navbar company={this.props.company}
							pathname={this.props.location.pathname}
							match={this.props.match}
							history={this.props.history}
							toggleMenuCollapsed={this.toggleMenuCollapsed.bind(this)}
						/>

						<div id="wrapper">

							<div id="page-wrapper" className="gray-bg px-0" style={{ marginLeft: '79px' }}>


								<div className="container-fluid">
									{!this.props.company.company || !this.props.users.users // only check for these two.  Other tables, check on individual pages.
										? < div style={{ position: 'absolute', top: '50%', left: '50%' }}>
											<Spinner />
										</div>
										: <>
											<Route path={this.props.match.path + '/dashboard/:message_id?'} render={(route_props) =>
												<div className="row">
													<div className='col-12'>
														<CatchErrors className={'m-t-lg'}>
															<Dashboard {...route_props} />
														</CatchErrors>
													</div>
												</div>
											} />
											<Route path={this.props.match.path + '/assets'} render={(route_props) =>
												<div className="row">
													<React.Suspense fallback={<Spinner style={{ marginTop: '20%' }} />}>
														<div className='col-12'>

															<CatchErrors className={'m-t-lg'}>
																<Assets {...route_props} />
															</CatchErrors>
														</div>
													</React.Suspense>
												</div>
											} />
											<Route path={this.props.match.path + '/schedule'} render={(route_props) =>
												<div className="row">
													<React.Suspense fallback={<Spinner style={{ marginTop: '20%' }} />}>
														<CatchErrors className={'m-t-lg'}>
															<Schedule {...route_props} />
														</CatchErrors>
													</React.Suspense>
												</div>
											} />
											<Route path={this.props.match.path + '/stock_parts'} render={(route_props) =>
												<div className="row">
													<React.Suspense fallback={<Spinner style={{ marginTop: '20%' }} />}>
														<CatchErrors className={'m-t-lg'}>
															<StockParts {...route_props} />
														</CatchErrors>
													</React.Suspense>
												</div>
											} />
											<Route path={this.props.match.path + '/vendors/:type'} render={(route_props) =>
												<div className="row">
													<React.Suspense fallback={<Spinner style={{ marginTop: '20%' }} />}>
														<CatchErrors className={'m-t-lg'}>
															<Vendors {...route_props} />
														</CatchErrors>
													</React.Suspense>
												</div>
											} />
											<Route path={this.props.match.path + '/employees'} render={(route_props) =>
												<div className="row">
													<React.Suspense fallback={<Spinner style={{ marginTop: '20%' }} />}>
														<CatchErrors className={'m-t-lg'}>
															<Employees {...route_props} app="maintenance" />
														</CatchErrors>
													</React.Suspense>
												</div>
											} />
											<Route path={this.props.match.path + '/settings'} render={(route_props) =>
												<React.Suspense fallback={<Spinner style={{ marginTop: '20%' }} />}>
													<CatchErrors className={'m-t-lg'}>
														<Settings {...route_props} />
													</CatchErrors>
												</React.Suspense>
											} />
											<Route path={this.props.match.path + '/archive'} render={(route_props) =>
												<div className="row">
													<CatchErrors className={'m-t-lg'}>
														<Archive {...route_props} />
													</CatchErrors>
												</div>
											} />
										</>
									}
									<Footer />
								</div>
							</div>
						</div>
					</>
				} />
			</Switch>
		);
	}
};

const mapStateToProps = function (store) {
	return {
		company: store.company,
		customers: store.customers,
		users: store.users,
		services: store.services,
		settings: store.settings,
	};
};

export default withRouter(connect(mapStateToProps)(App));
